import React from 'react';
import { NewHireProps } from '../../../models/arc-epi-props';
import { Employee } from '../../employment/employment-model';

interface Props {
    newHireProps: NewHireProps;
    employee: Employee;
    nonStip: boolean;
}
export function NewHireInternalPersonReview(props: Props) {
    const { newHireProps, employee, nonStip } = props;

    return (
        <p>{(nonStip ? newHireProps?.nonStipInternalEmployeeMessage : newHireProps?.stipInternalEmployeeMessage)?.replace('{name}', employee?.full_name)}</p>
    );
}